import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit-more",
  "use": "icon-edit-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edit-more\"><path d=\"M224 512m-80 0a80 80 0 1 0 160 0 80 80 0 1 0-160 0Z\" p-id=\"1655\" /><path d=\"M512 512m-80 0a80 80 0 1 0 160 0 80 80 0 1 0-160 0Z\" p-id=\"1656\" /><path d=\"M800 512m-80 0a80 80 0 1 0 160 0 80 80 0 1 0-160 0Z\" p-id=\"1657\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol